<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="交易时间">
      <!-- <el-date-picker
        v-model="dateRange"
        type="daterange"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        range-separator="-"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        :disabled-date="disabledDate"
        @change="handleDateChange"
      /> -->
      <el-date-picker
        v-model="dateStartRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="开始时间"
        :disabled-date="disabledDate"
        @change="handleDateStartChange"
      />
      <el-date-picker
        v-model="dateEndRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="结束时间"
        :disabled-date="disabledDate"
        @change="handleDateEndChange"
      />
    </el-form-item>
    <el-form-item label="平台订单号">
      <el-input
        v-model="queryParam.platformnum"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('platformnum', { unique: true })"
      />
    </el-form-item>
    <el-form-item label="垚旌订单号">
      <el-input
        v-model="queryParam.ordernum"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('ordernum', { unique: true })"
      />
    </el-form-item>
    <!-- <el-form-item label="垚旌父订单号">
      <el-input
        v-model="queryParam.pordernum"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
      />
    </el-form-item> -->
    <el-form-item label="商品名称">
      <el-input v-model="queryParam.name" placeholder="输入商品名称" />
    </el-form-item>
    <el-form-item label="客户">
      <el-select
        v-model="queryParam.customerid"
        multiple
        filterable
        placeholder="选择客户"
      >
        <template v-for="item in customerData" :key="item.customerid">
          <el-option :label="item.name" :value="item.customerid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="供应商">
      <el-select
        v-model="queryParam.supplierid"
        multiple
        filterable
        placeholder="选择供应商"
      >
        <template v-for="item in supplierData" :key="item.supplierid">
          <el-option :label="item.name" :value="item.supplierid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="收货人姓名">
      <el-input
        v-model="queryParam.receiver"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('receiver', { unique: true })"
      />
    </el-form-item>
    <el-form-item label="收货人电话">
      <el-input
        v-model="queryParam.receiverphone"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('receiverphone', { unique: true })"
      />
    </el-form-item>
    <el-form-item label="订单状态">
      <el-select v-model="queryParam.orderstatus" placeholder="订单状态">
        <el-option label="待发货" :value="1" />
        <el-option label="备货中" :value="2" />
        <el-option label="发货失败" :value="3" />
        <el-option label="已发货" :value="4" />
        <el-option label="发货完结" :value="5" />
        <el-option label="已取消" :value="6" />
      </el-select>
    </el-form-item>
    <el-form-item label="订单完成时间">
      <el-date-picker
        v-model="completed"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="请选择订单完成时间"
        @blur="changeCompleted"
      />
    </el-form-item>
    <el-form-item label="客户对账状态">
      <el-select v-model="queryParam.cusstatus" placeholder="客户对账状态">
        <el-option label="已对账" :value="1" />
        <el-option label="未对账" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item label="客户收款状态">
      <el-select v-model="queryParam.cuspaystatus" placeholder="客户收款状态">
        <el-option label="已收款" :value="1" />
        <el-option label="未收款" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item label="供应商对账状态">
      <el-select v-model="queryParam.supstatus" placeholder="供应商对账状态">
        <el-option label="已对账" :value="1" />
        <el-option label="未对账" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item label="供应商付款状态">
      <el-select v-model="queryParam.suppaystatus" placeholder="供应商付款状态">
        <el-option label="已付款" :value="1" />
        <el-option label="未付款" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item label="客户账期">
      <el-select v-model="queryParam.cisaccount" placeholder="选择客户账期">
        <el-option label="日" :value="1" />
        <el-option label="周" :value="2" />
        <el-option label="月" :value="3" />
        <el-option label="半月" :value="4" />
        <el-option label="年结" :value="5" />
      </el-select>
    </el-form-item>
    <el-form-item label="供应商账期">
      <el-select v-model="queryParam.sisaccount" placeholder="选择供应商账期">
        <el-option label="日" :value="1" />
        <el-option label="周" :value="2" />
        <el-option label="月" :value="3" />
        <el-option label="半月" :value="4" />
        <el-option label="年结" :value="5" />
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="danger" @click="getListOrderVerify">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="primary"
          :loading="loadingStata"
          @click="doOrderVerifyStat()"
          >数据总览</el-button
        >
        <el-button
          type="danger"
          @click="openImport('finance:importcustomer')"
          v-hasPermission="['finance:importcustomer']"
          >导入客户对账</el-button
        >
        <el-button
          type="danger"
          @click="openImport('finance:importsupplier')"
          v-hasPermission="['finance:importsupplier']"
          >导入供应商对账</el-button
        >
        <el-button
          type="danger"
          @click="showExportOrderDialog"
          v-hasPermission="['finance:export']"
          >导出对账</el-button
        >
      </div>
    </el-col>
  </el-row>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-tabs class="tabs-log" v-model="activeTabName" @tab-click="doTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane name="cusuncomplete">
          <template #label>
            <span class="custom-tabs-label">
              <span>客户未对账</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderVerify.countOrderVerifyCustomerUn}}</el-link>
            </span>
          </template>
          <div class="waitTab">
            <span>销售总额：<el-tag type="danger">{{countOrderVerify.customerUnSaleamount}}</el-tag>元</span>
            <span style="margin-left:50px">成本总额：<el-tag type="danger">{{countOrderVerify.customerUnCostamount}}</el-tag>元</span>
          </div>
        </el-tab-pane>
        <el-tab-pane name="cuscomplete">
          <template #label>
            <span class="custom-tabs-label">
              <span>客户已对账</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderVerify.countOrderVerifyCustomer}}</el-link>
            </span>
          </template>
          <div class="waitTab">
            <span>销售总额：<el-tag type="danger">{{countOrderVerify.customerSaleamount}}</el-tag>元</span>
            <span style="margin-left:50px">成本总额：<el-tag type="danger">{{countOrderVerify.customerSaleamount}}</el-tag>元</span>
          </div>
        </el-tab-pane>


        <el-tab-pane name="cuspayuncomplete">
          <template #label>
            <span class="custom-tabs-label">
              <span>客户未收款</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderVerify.countOrderVerifyCustomerPayUn}}</el-link>
            </span>
          </template>
          <div class="waitTab">
            <span>销售总额：<el-tag type="danger">{{countOrderVerify.customerSaleamountPayUn}}</el-tag>元</span>
            <span style="margin-left:50px">成本总额：<el-tag type="danger">{{countOrderVerify.customerCostamountPayUn}}</el-tag>元</span>
          </div>
        </el-tab-pane>
        <el-tab-pane name="cuspaycomplete">
          <template #label>
            <span class="custom-tabs-label">
              <span>客户已收款</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderVerify.countOrderVerifyCustomerPay}}</el-link>
            </span>
          </template>
          <div class="waitTab">
            <span>销售总额：<el-tag type="danger">{{countOrderVerify.customerSaleamountPay}}</el-tag>元</span>
            <span style="margin-left:50px">成本总额：<el-tag type="danger">{{countOrderVerify.customerCostamountPay}}</el-tag>元</span>
          </div>
        </el-tab-pane>


        <el-tab-pane name="supuncomplete">
          <template #label>
            <span class="custom-tabs-label">
              <span>供应商未对账</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderVerify.countOrderVerifySupplierUn}}</el-link>
            </span>
          </template>
          <div class="waitTab">
            <span>销售总额：<el-tag type="danger">{{countOrderVerify.supplierSaleamountUn}}</el-tag>元</span>
            <span style="margin-left:50px">成本总额：<el-tag type="danger">{{countOrderVerify.supplierCostamountUn}}</el-tag>元</span>
          </div>
        </el-tab-pane>
        <el-tab-pane name="supcomplete">
          <template #label>
            <span class="custom-tabs-label">
              <span>供应商已对账</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderVerify.countOrderVerifySupplier}}</el-link>
            </span>
          </template>
          <div class="waitTab">
            <span>销售总额：<el-tag type="danger">{{countOrderVerify.supplierSaleamount}}</el-tag>元</span>
            <span style="margin-left:50px">成本总额：<el-tag type="danger">{{countOrderVerify.supplierCostamount}}</el-tag>元</span>
          </div>
        </el-tab-pane>

        <el-tab-pane name="suppayuncomplete">
          <template #label>
            <span class="custom-tabs-label">
              <span>供应商未付款</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderVerify.countOrderVerifySupplierPayUn}}</el-link>
            </span>
          </template>
          <div class="waitTab">
            <span>销售总额：<el-tag type="danger">{{countOrderVerify.supplierSaleamountPayUn}}</el-tag>元</span>
            <span style="margin-left:50px">成本总额：<el-tag type="danger">{{countOrderVerify.supplierCostamountPayUn}}</el-tag>元</span>
          </div>
        </el-tab-pane>
        <el-tab-pane name="suppaycomplete">
          <template #label>
            <span class="custom-tabs-label">
              <span>供应商已付款</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderVerify.countOrderVerifySupplierPay}}</el-link>
            </span>
          </template>
          <div class="waitTab">
            <span>销售总额：<el-tag type="danger">{{countOrderVerify.supplierSaleamountPay}}</el-tag>元</span>
            <span style="margin-left:50px">成本总额：<el-tag type="danger">{{countOrderVerify.supplierCostamountPay}}</el-tag>元</span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table
        :data="tableData"
        v-loading="loadingData"
        @selection-change="doSelectionOrder"
        class="mainTable"
        row-key="orderid"
        height="600"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="平台交易时间" prop="platformed" width="155">
          <template #default="scope">
            <span v-text="util.formatDateUnix(scope.row.platformed, 'yyyy-MM-dd hh:mm')"></span>
          </template>
        </el-table-column>
        <el-table-column label="客户" prop="customer.name" width="100" />
        <el-table-column label="平台订单号" prop="platformnum" width="200" />
        <el-table-column label="垚旌订单号" prop="ordernum" width="250" />
        <!-- <el-table-column label="父垚旌订单号" prop="pordernum" width="220" /> -->
        <el-table-column label="商品名称" prop="name" width="200" />
        <el-table-column label="成本金额" align="center" prop="costamount">
          <template #default="scope">
            <span v-if="scope.row.costamount" v-text="(scope.row.costamount).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="应付金额" align="center" prop="orderVerify.suppayamount">
          <template #default="scope">
            <span v-if="scope.row.orderVerify.suppayamount" v-text="(scope.row.orderVerify.suppayamount).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="成本差额" align="center" prop="orderVerify.supcompensation">
          <template #default="scope">
            <span v-if="scope.row.orderVerify.supcompensation" v-text="(scope.row.orderVerify.supcompensation).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="毛利率" align="center" prop="maoliv" width="120">
          <template #default="scope">
            <span v-if="scope.row.maoliv" v-text="(scope.row.maoliv*100).toFixed(2) + '%'" />
            <el-tag
              round
              :type="scope.row.maolivstatus === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showOrderMaoliv(scope.row.maolivstatus)"></span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="销售金额" align="center" prop="saleamount">
          <template #default="scope">
            <span v-if="scope.row.saleamount" v-text="(scope.row.saleamount).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="应收金额" align="center" prop="orderVerify.cuspaidamount">
          <template #default="scope">
            <span v-if="scope.row.orderVerify.cuspaidamount" v-text="(scope.row.orderVerify.cuspaidamount).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="销售差额" align="center" prop="orderVerify.cuscompensation">
          <template #default="scope">
            <span v-if="scope.row.orderVerify.cuscompensation" v-text="(scope.row.orderVerify.cuscompensation).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="供应商" align="center"  prop="supplier.name" />
        <el-table-column label="订单状态" align="center" prop="orderstatus">
          <template #default="scope">
            <!-- 待发货、备货中、发货失败、已发货、发货完结、已取消 -->
            <template v-if="scope.row.orderstatus==1">
              <el-tag
              round
              disable-transitions
              ><span v-text="util.showOrderStatus(scope.row.orderstatus)"></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==2">
              <el-tag
              round
              type="danger"
              disable-transitions
              ><span v-text="util.showOrderStatus(scope.row.orderstatus)"></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==3">
              <el-tag
              round
              type="warning"
              disable-transitions
              ><span v-text="util.showOrderStatus(scope.row.orderstatus)"></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==4">
              <el-tag
              round
              type="success"
              disable-transitions
              ><span
                v-text="util.showOrderStatus(scope.row.orderstatus)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==5">
              <el-tag
              round
              type="success"
              disable-transitions
              ><span
                v-text="util.showOrderStatus(scope.row.orderstatus)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==6">
              <el-tag
              round
              type="danger"
              disable-transitions
              ><span v-text="util.showOrderStatus(scope.row.orderstatus)"></span>
              </el-tag>
            </template>
          </template>
        </el-table-column>
        
        <el-table-column
          label="收货人姓名"
          align="center"
          prop="orderAddress.receiver"
          width="100"
        />
        <el-table-column
          label="收货人电话"
          prop="orderAddress.receiverphone"
          width="120"
        />
        <el-table-column
          label="快递单号"
          prop="orderAddress.expressnum"
          width="150"
        />
        <el-table-column
          label="发货时间"
          prop="orderAddress.deliveryed"
          width="150"
        >
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(
                  scope.row.orderAddress.deliveryed,
                  'yyyy-MM-dd hh:mm'
                )
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="客户下单备注" prop="ordernote" width="150" />
        <el-table-column label="后端处理备注" prop="orderAddress.deliverynote" width="200" />
        <el-table-column
          label="客户对账时间"
          prop="orderVerify.cuspaided"
          width="150"
        >
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(
                  scope.row.orderVerify.cuspaided,
                  'yyyy-MM-dd hh:mm'
                )
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column
          label="供应商对账时间"
          prop="orderVerify.suppayed"
          width="150"
        >
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(
                  scope.row.orderVerify.suppayed,
                  'yyyy-MM-dd hh:mm'
                )
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="showFinanceCustomerDialog(scope.row)"
              v-hasPermission="['finance:edit']"
              >客户对账</el-link
            >
            <el-link
              type="primary"
              size="small"
              @click="showFinanceSupplierDialog(scope.row)"
              v-hasPermission="['finance:edit']"
              >供应商对账</el-link
            >
            <el-link
              type="primary"
              size="small"
              @click="open('finance:view', scope.row)"
              v-hasPermission="['finance:view']"
              >详情</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="12">
      <div>
        <el-button type="danger" @click="showBatchFinanceCustomerDialog" v-hasPermission="['finance:batch']"
          >批量修改客户对账状态</el-button
        >
        <el-button type="danger" @click="showBatchFinanceSupplierDialog" v-hasPermission="['finance:batch']"
          >批量修改供应商对账状态</el-button
        >
      </div>
    </el-col>
    <el-col :span="12">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
        />
      </div>
    </el-col>
  </el-row>

  <FinanceCustomer ref="RefFinanceCustomer" @click="getListOrderVerify"/>
  <FinanceSupplier ref="RefFinanceSupplier" @click="getListOrderVerify" />
  <BatchFinanceCustomer ref="RefBatchFinanceCustomer" @click="getListOrderVerify" />
  <BatchFinanceSupplier ref="RefBatchFinanceSupplier" @click="getListOrderVerify" />
  <ExportOrder ref="RefExportOrder" />
</template>
        
<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElTable, ElMessage } from "element-plus";
import { listOrderVerify,getOrderVerifyCount } from "@/api/order/verify";
import { listSupplierCache } from "@/api/supplier";
import { listCustomerCache } from "@/api/customer";
import util from "@/util/tool.js";
import storage from  "@/util/storage";

// import store from "@/store";

import FinanceCustomer from "@/components/common/financeCustomer";
import FinanceSupplier from "@/components/common/financeSupplier";
import BatchFinanceCustomer from "@/components/common/batchFinanceCustomer";
import BatchFinanceSupplier from "@/components/common/batchFinanceSupplier";
import ExportOrder from "@/components/common/exportOrder";

const loadingData = ref(true);

const loadingStata = ref(false);

// let dateRange = ref([]);
let dateStartRange = ref();
let dateEndRange = ref();

const router = useRouter();
let open = (routeName, row) => {
  storage.saveSessionObject("financePath",queryParam.value)
  router.push({
    name: routeName,
    params: { id: row.orderid },
    //query: { name: row.name },
  });
};
let openImport = (routeName) => {
  router.push({
    name: routeName,
  });
};

const total = ref(0);
const pageSize = ref(20); //每页显示条数

const activeTabName = ref("all");
const doTabClick = (tab) => {
  if (tab.props.name === "all") {
    queryParam.value.cusstatus = ''
    queryParam.value.cuspaystatus = ''
    queryParam.value.supstatus = ''
    queryParam.value.suppaystatus = ''
  } else if (tab.props.name == "cusuncomplete") {
    queryParam.value.cusstatus = 2
    queryParam.value.cuspaystatus = ''
    queryParam.value.supstatus = ''
    queryParam.value.suppaystatus = ''
  } else if (tab.props.name == "cuscomplete") {
    queryParam.value.cusstatus = 1
    queryParam.value.cuspaystatus = ''
    queryParam.value.supstatus = ''
    queryParam.value.suppaystatus = ''
  } else if (tab.props.name == "cuspayuncomplete") {
    queryParam.value.cusstatus = ''
    queryParam.value.cuspaystatus = 2
    queryParam.value.supstatus = ''
    queryParam.value.suppaystatus = ''
  } else if (tab.props.name == "cuspaycomplete") {
    queryParam.value.cusstatus = ''
    queryParam.value.cuspaystatus = 1
    queryParam.value.supstatus = ''
    queryParam.value.suppaystatus = ''
  } else if (tab.props.name == "supuncomplete") {
    queryParam.value.cusstatus = ''
    queryParam.value.cuspaystatus = ''
    queryParam.value.supstatus = 2
    queryParam.value.suppaystatus = ''
  } else if (tab.props.name == "supcomplete") {
    queryParam.value.cusstatus = ''
    queryParam.value.cuspaystatus = ''
    queryParam.value.supstatus = 1
    queryParam.value.suppaystatus = ''
  } else if (tab.props.name == "suppayuncomplete") {
    queryParam.value.cusstatus = ''
    queryParam.value.cuspaystatus = ''
    queryParam.value.supstatus = ''
    queryParam.value.suppaystatus = 2
  } else if (tab.props.name == "suppaycomplete") {
    queryParam.value.cusstatus = ''
    queryParam.value.cuspaystatus = ''
    queryParam.value.supstatus = ''
    queryParam.value.suppaystatus = 1
  }
  getListOrderVerify();
};

const multipleSelection = ref([]);
const doSelectionOrder = (val) => {
  multipleSelection.value = val;
  // console.log("multipleSelection.value----", multipleSelection.value);
};


//订单导出
let dialogExportOrderVisible = ref(false);
const RefExportOrder = ref();
const showExportOrderDialog = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  RefExportOrder.value.changeVisible(!dialogExportOrderVisible.value);
  RefExportOrder.value.exportOrderMethod(queryParam.value);
  RefExportOrder.value.exportAction('verify');
};

//客户对账
let dialogFinanceCustomerVisible = ref(false);
const RefFinanceCustomer = ref();
const showFinanceCustomerDialog = (obj) => {
  RefFinanceCustomer.value.changeVisible(!dialogFinanceCustomerVisible.value);

  let amount = obj.orderVerify.cuspaidamount?obj.orderVerify.cuspaidamount:obj.saleamount
  amount = obj.orderVerify.cuscompensation? amount+obj.orderVerify.cuscompensation:amount

  RefFinanceCustomer.value.customerMethod({
    cusstatus: obj.orderVerify.cusstatus,
    cuspaystatus: obj.orderVerify.cuspaystatus,
    cuscompensation: obj.orderVerify.cuscompensation,
    cuspaidamount: amount,
    saleamount: obj.saleamount,
    cussetstatus: obj.orderVerify.cussetstatus,
    cusistax: obj.orderVerify.cusistax?obj.orderVerify.cusistax:'',
    cusnote: obj.orderVerify.cusnote,
    orderid: obj.orderid,
  });
};
//供应商对账
let dialogFinanceSupplierVisible = ref(false);
const RefFinanceSupplier = ref();
const showFinanceSupplierDialog = (obj) => {
  RefFinanceSupplier.value.changeVisible(!dialogFinanceSupplierVisible.value);

  let amount = obj.orderVerify.suppayamount?obj.orderVerify.suppayamount:obj.costamount
  amount = obj.orderVerify.supcompensation? amount+obj.orderVerify.supcompensation:amount

  RefFinanceSupplier.value.supplierMethod({
    supstatus: obj.orderVerify.supstatus,
    suppaystatus: obj.orderVerify.suppaystatus,
    supcompensation: obj.orderVerify.supcompensation,
    suppayamount: amount,
    costamount: obj.costamount,
    supsetstatus: obj.orderVerify.supsetstatus,
    supistax: obj.orderVerify.supistax,
    supnote: obj.orderVerify.supnote,
    orderid: obj.orderid,
  });
};

let dialogBatchFinanceCustomerVisible = ref(false);
const RefBatchFinanceCustomer = ref();
const showBatchFinanceCustomerDialog = () => {
  if (multipleSelection.value.length <= 0) {
    ElMessage.error("请先选择要处理的订单项");
    return false;
  }
  RefBatchFinanceCustomer.value.changeVisible(
    !dialogBatchFinanceCustomerVisible.value
  );

  let orderids = [];
  let cuscompensations = [];
  multipleSelection.value.forEach((order) => {
    orderids.push(order.orderid.toString());
    cuscompensations.push(order.orderVerify.cuscompensation?order.orderVerify.cuscompensation:0);
  });

  // console.log(orderids.join(","));
  RefBatchFinanceCustomer.value.customerMethod({
    orderid: orderids,
    cuscompensation: cuscompensations
  });
};

let dialogBatchFinanceSupplierVisible = ref(false);
const RefBatchFinanceSupplier = ref();
const showBatchFinanceSupplierDialog = () => {
  if (multipleSelection.value.length <= 0) {
    ElMessage.error("请先选择要处理的订单项");
    return false;
  }
  RefBatchFinanceSupplier.value.changeVisible(
    !dialogBatchFinanceSupplierVisible.value
  );

  let orderids = [];
  let supcompensations = [];
  multipleSelection.value.forEach((order) => {
    orderids.push(order.orderid.toString());
    supcompensations.push(order.orderVerify.supcompensation?order.orderVerify.supcompensation:0);
  });

  // console.log(orderids.join(","));
  RefBatchFinanceSupplier.value.supplierMethod({
    orderid: orderids,
    supcompensation: supcompensations
  });
};


const countOrderVerify = ref({
  countOrderVerifyCustomerUn: 0,
  customerUnSaleamount: 0,
  customerUnCostamount: 0,

  countOrderVerifyCustomer: 0,
  customerSaleamount: 0,
  customerCostamount: 0,

  countOrderVerifyCustomerPayUn: 0,
  customerSaleamountPayUn: 0,
  customerCostamountPayUn: 0,

  countOrderVerifyCustomerPay: 0,
  customerSaleamountPay: 0,
  customerCostamountPay: 0,

  countOrderVerifySupplierUn: 0,
  supplierSaleamountUn: 0,
  supplierCostamountUn: 0,

  countOrderVerifySupplier: 0,
  supplierSaleamount: 0,
  supplierCostamount: 0,

  countOrderVerifySupplierPayUn: 0,
  supplierSaleamountPayUn: 0,
  supplierCostamountPayUn: 0,

  countOrderVerifySupplierPay: 0,
  supplierSaleamountPay: 0,
  supplierCostamountPay: 0
})
const getOrderVerifyCounts = () => {
  if (!dateStartRange.value || !dateEndRange.value) {
    defaultDate()
  }
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.supplierids = query.supplierid?query.supplierid.join(','):''
  query.customerids = query.customerid?query.customerid.join(','):''
  delete query.customerid
  delete query.supplierid
  console.log(query)

  loadingStata.value = true;

  getOrderVerifyCount(query).then((res)=>{
    countOrderVerify.value = res.data.extend
    setTimeout(() => {
        loadingStata.value = false;
    }, 400);
  })
}


//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  platformed: "",
  platformnum: "",
  ordernum: "",
  pordernum: "",
  name: "",
  customerid: "",
  supplierid: "",
  expressnum: "",
  receiver: "",
  receiverphone: "",
  maolivstatus: "",
  orderstatus: "",
  completed: "",
  cusstatus: "",
  cuspaystatus: "",
  supstatus: "",
  suppaystatus: "",
  cisaccount:"",
  sisaccount:"",
  created: "",
  changed: "",
});

const autoFormat = (key, opt = {}) => {
  queryParam.value[key] = util.formatLineText(queryParam.value[key], opt);
};

// let platformed = ref();
// const changePlatformed = () => {
//   queryParam.value.created = Date.parse(platformed.value[0] + " 00:00:00");
//   queryParam.value.changed = Date.parse(platformed.value[1] + " 23:59:59");
// };

let completed = ref();
const changeCompleted = () => {
  queryParam.value.completed = Date.parse(completed.value + " 00:00:00");
}

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    platformed: "",
    platformnum: "",
    ordernum: "",
    pordernum: "",
    name: "",
    customerid: "",
    supplierid: "",
    expressnum: "",
    receiver: "",
    receiverphone: "",
    maolivstatus: "",
    orderstatus: "",
    completed: "",
    cusstatus: "",
    cuspaystatus: "",
    supstatus: "",
    suppaystatus: "",
    cisaccount:"",
    sisaccount:"",
    created: "",
    changed: "",
  };
  defaultDate()
  getListOrderVerify();
};

const defaultDate = () => {
    const today = new Date()
    const halfYearAgo = new Date(today)
    // 往前推6个月
    halfYearAgo.setMonth(halfYearAgo.getMonth() - 6)

    // 格式化日期 YYYY-MM-DD
    const formatDate = (date) => date.toISOString().slice(0, 10)

    // 赋值默认范围
    // dateRange.value = [
    //   formatDate(halfYearAgo),
    //   formatDate(today)
    // ]
    // queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
    // queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");

     dateStartRange.value =  formatDate(halfYearAgo)
     dateEndRange.value = formatDate(today)
     queryParam.value.created = Date.parse(dateStartRange.value + " 00:00:00");
     queryParam.value.changed = Date.parse(dateEndRange.value + " 23:59:59");
  }
// 2. 禁用逻辑：不能选未来，范围最6个月
const disabledDate = (time) => {
  console.log(time)
  // const now = Date.now()

  // 1. 禁用未来日期
  // if (time.getTime() > now) return true

  // 2. 已选开始日期 → 结束日期只能选 开始 ~ 开始+6个月
  // if (dateRange.value?.[0]) {
  //   const start = new Date(dateRange.value[0])
  //   const maxEnd = new Date(start)
  //   maxEnd.setMonth(maxEnd.getMonth() + 6) // 加6个月

  //   return time.getTime() < start || time.getTime() > maxEnd
  // }
  // if (dateStartRange.value) {
  //   const start = new Date(dateStartRange.value)
  //   const maxEnd = new Date(start)
  //   maxEnd.setMonth(maxEnd.getMonth() + 6) // 加6个月

  //   return time.getTime() < start || time.getTime() > maxEnd
  // }

  // return false
}
// 三、防止手动输入超过6个月
// const handleDateChange = () => {
//   if (!dateRange.value[0] || !dateRange.value[1]) return

//   const start = new Date(dateRange.value[0])
//   const end = new Date(dateRange.value[1])
//   const maxEnd = new Date(start)
//   maxEnd.setMonth(maxEnd.getMonth() + 6)

//   // 如果超出6个月，自动修正结束时间
//   if (end > maxEnd) {
//     dateRange.value[1] = maxEnd.toISOString().slice(0, 10)
//   }
//   queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
//   queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");
// }

const handleDateStartChange = () => {
  if (!dateStartRange.value) return
  if (dateEndRange.value) {
    if (dateStartRange.value > dateEndRange.value) {
      dateStartRange.value = ""
      queryParam.value.created = ""
      ElMessage.error('开始时间须小于结束时间');
      return false
    }
  }
  queryParam.value.created = Date.parse(dateStartRange.value + " 00:00:00");
}

const handleDateEndChange = () => {
  if (!dateEndRange.value) return

  if (dateStartRange.value > dateEndRange.value) {
    dateStartRange.value = ""
    queryParam.value.created = ""
    ElMessage.error('开始时间须小于结束时间');
    return false
  }
  queryParam.value.changed = Date.parse(dateEndRange.value + " 23:59:59");
}

const tableData = ref([]);

//客户列表API
const customerData = ref([]);
const customerReset = (customers) => {
  let dataTmp = [];
  customers.forEach((customer) => {
    customer.customerid = customer.customerid.toString();
    dataTmp.push(customer);
  });
  return dataTmp;
};
const getListCustomer = () => {
  listCustomerCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    customerData.value = customerReset(res.data.extend.pages.list);
  });
};

//供应商列表API
const supplierData = ref([]);
const supplierReset = (suppliers) => {
  let dataTmp = [];
  suppliers.forEach((supplier) => {
    supplier.supplierid = supplier.supplierid.toString();
    dataTmp.push(supplier);
  });
  return dataTmp;
};
const getListSupplier = () => {
  listSupplierCache({ pageNo: 1, pageSize: 5000, status: 1 }).then((res) => {
    supplierData.value = supplierReset(res.data.extend.pages.list);
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListOrderVerify();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListOrderVerify();
};

//订单表API
const getListOrderVerify = () => {
  storage.remove('financePath')

  if (!dateStartRange.value || !dateEndRange.value) {
    defaultDate()
  }
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.supplierids = query.supplierid?query.supplierid.join(','):''
  query.customerids = query.customerid?query.customerid.join(','):''
  delete query.customerid
  delete query.supplierid
  console.log(query)
  listOrderVerify(query).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false
  });
};

const doOrderVerifyStat = () => {
  getOrderVerifyCounts();
}

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("financePath")
  if (query) {
    queryParam.value = query
  }

  defaultDate()

  getListCustomer();
  getListSupplier();
  getListOrderVerify();
});
</script>
<style scoped>
.waitTab {
  margin-top: 15px;
  font-size:14px;
}
.waitTab .item {
  margin-right: 40px;
}
</style>